import React, { FC, Fragment, useCallback } from 'react';
import { Waypoint } from 'react-waypoint';

import { CardTypeOptions } from 'constants/graphqlTypes';
import { useFollowingItems } from 'graphQL/cards/exploreCards/hooks';
import LoaderContent from 'components/UI/LoaderContent/LoaderContent';
import Loader from 'components/UI/Loader';
import { useRefreshDetection } from 'helpers/useRefreshDetection';
import useTheme from 'helpers/useTheme';
import { getKey } from './helpers';
import TabItem from './TabItem';

import { StyledContent, StyledSection, StyledRefreshLoader } from '../styled';

const FollowingTab: FC = () => {
  const { items, loading, loadMore, shouldLoadPrevDay, loadPrevDay } = useFollowingItems();
  const { shouldShow, isRefreshing } = useRefreshDetection('Following', loading);
  const isDark = useTheme();

  const isSuggestedUserFirst =
    items?.[0]?.__typename === 'CardSchema' && items?.[0].type === CardTypeOptions.SuggestedUsers;

  // Simple load more handler - no scroll position manipulation
  const handleLoadMore = useCallback(() => {
    if (shouldLoadPrevDay) {
      loadPrevDay();
    } else {
      loadMore();
    }
  }, [shouldLoadPrevDay, loadPrevDay, loadMore]);

  return items ? (
    <>
      <StyledSection>
        <StyledRefreshLoader isRefreshing={isRefreshing}>
          <Loader isDark={isDark} size={32} />
        </StyledRefreshLoader>
        {/* <Heading
          section={{
            headType: EDiscoverSlotHeadTypeOptions.Simple,
            title: isSuggestedUserFirst ? 'Follow people that inspire you' : 'Latest picks from everyone you follow',
          }}
          shouldShow={shouldShow}
        /> */}
        <StyledContent>
          {items?.map((item, index) => (
            <Fragment key={getKey(item)}>
              <TabItem currentItem={item} items={items} isFirstItem={index === 0} />
              {/* Add multiple waypoints like featured feed */}
              {(items.length === 1 || index === items.length - 4 || index === items.length - 1) && (
                <Waypoint onEnter={handleLoadMore} />
              )}
            </Fragment>
          ))}
        </StyledContent>
      </StyledSection>
      {/* Final waypoint at the end */}
      {!loading && <Waypoint onEnter={handleLoadMore} />}
      {loading && <LoaderContent isFullScreen={false} />}
    </>
  ) : null;
};

export default FollowingTab;
